var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputEditActionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1752_53942)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6425 1.35776C16.387 1.10337 16.0837 0.902114 15.75 0.765627C15.4163 0.629139 15.0588 0.560122 14.6983 0.562563C14.3377 0.565003 13.9813 0.638853 13.6494 0.779847C13.3176 0.92084 13.017 1.12618 12.765 1.38401L1.89 12.259L0.5625 17.4378L5.74125 16.1095L16.6163 5.23451C16.8741 4.98261 17.0796 4.68209 17.2206 4.35032C17.3616 4.01855 17.4355 3.66211 17.438 3.30161C17.4404 2.94111 17.3714 2.58371 17.2348 2.25006C17.0983 1.91641 16.897 1.61313 16.6425 1.35776Z",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4546 1.69531L16.3051 5.54581",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.89062 12.2578L5.74487 16.1053",
    stroke: "black",
    strokeWidth: 1.125,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1752_53942"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputEditActionIcon);
export default __webpack_public_path__ + "static/media/InputEditActionIcon.9dbb9f6e3d953303fb4b65bb9762a5f7.svg";
export { ForwardRef as ReactComponent };